export class LoginUserAction {
  static readonly type = '[User] Login User';
  constructor(public name: string, public password: string) {}
}

export class VerifyTwoFactorAction {
  static readonly type = '[User] Verify Two Factor';
  constructor(public code: string) {}
}

export class LogoutUserAction {
  static readonly type = '[User] Logout User';
  constructor() {}
}

export class BackToAuthAction {
  static readonly type = '[User] Back To Auth';
  constructor() {}
}
